export const buildContentCoursePath = (nodes, courseID) => {
  const nodeIDs = buildNodeIDs(nodes, courseID)
  return nodeIDs.reduce((acc, id) => (id === courseID ? acc + `/course/${id}` : acc + `/node/${id}`), '/org/node-content')
}

export const buildContentCategoryPath = (nodes, categoryID) => {
  const nodeIDs = buildNodeIDs(nodes, categoryID)
  return nodeIDs.reduce((acc, id) => acc + `/node/${id}`, '/org/node-content')
}

export const buildTemplatePath = (nodes, courseID) => {
  const nodeIDs = buildNodeIDs(nodes, courseID)
  return nodeIDs.reduce((acc, id) => (id === courseID ? acc + `/template/${id}` : acc + `/node/${id}`), '/org/node-template')
}

export const buildTemplateCategoryPath = (nodes, courseID) => {
  const nodeIDs = buildNodeIDs(nodes, courseID)
  return nodeIDs.reduce((acc, id) => acc + `/node/${id}`, '/org/node-template')
}

export const buildLibraryPath = (nodes, courseID) => {
  const nodeIDs = buildNodeIDs(nodes, courseID)
  return nodeIDs.reduce((acc, id) => (id === courseID ? acc + `/library/${id}` : acc + `/node/${id}`), '/org/node-library')
}

export const buildLibraryCategoryPath = (nodes, courseID) => {
  const nodeIDs = buildNodeIDs(nodes, courseID)
  return nodeIDs.reduce((acc, id) => acc + `/node/${id}`, '/org/node-library')
}

const buildNodeIDs = (nodes, nodeID) => {
  let node = nodes.find(node => node.id === nodeID)

  if (!node) {
    return []
  }

  if (node.parentID) {
    let ids = buildNodeIDs(nodes, node.parentID)
    ids.push(node.id)
    return ids
  } else {
    return [node.id]
  }
}
